import React from 'react';
import T from 'prop-types';
import { connect } from 'react-redux';
// components
import FieldWrapper from '../FieldWrapper';
import SingleDatePicker from 'components/DatePicker/SingleDatePicker/SingleDatePicker';
// hooks
import { useIntl } from 'react-intl';
// regional date handling
import { getCurrentCountryCode } from 'selectors/regionalDateSelectors';
import { getInputPlaceholder } from 'utils/regionalDateHelper';

const DatePickerField = ({
  input,
  isDisabled = false,
  label,
  meta,
  required,
  horizontal,
  countryCode,
  ...others
}) => {
  const { formatMessage } = useIntl();
  const regionalPlaceholder = getInputPlaceholder(countryCode);

  return (
    <FieldWrapper
      meta={meta}
      label={label}
      required={!input.value && required}
      horizontal={horizontal}
    >
      <SingleDatePicker
        {...input}
        {...others}
        date={input.value || null}
        disabled={isDisabled}
        onDateChange={input.onChange}
        inputLabel={regionalPlaceholder}
        placeholder={formatMessage({ id: 'general.selectDate' })}
      />
    </FieldWrapper>
  );
};

DatePickerField.propTypes = {
  input: T.object.isRequired,
  isDisabled: T.bool,
  label: T.node,
  meta: T.object,
  required: T.bool,
  horizontal: T.bool,
  countryCode: T.string,
};

DatePickerField.defaultProps = {
  countryCode: 'US',
};

export default connect(
  (state) => ({
    countryCode: getCurrentCountryCode(state)
  })
)(DatePickerField);
